import { createSlice } from "@reduxjs/toolkit";

export const auth = createSlice({
  name: "auth",
  initialState: {
    check: false,
  },
  reducers: {
    checkProfile: (state, action) => {
      state.check = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const authActions = auth.actions;
export const authReducer = auth.reducer;
